var $ = jQuery;
var windowWidth = $(window).width();

// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  productGridItemHtml: `<div class="col col-xs-6 col-md-4 col-lg-3 product-link product-link--grid" data-product-link data-wrapper-product-id="{{itemID}}" {{noImage}}> 
		<a href="{{itemUrl}}" class="product-link__image-wrapper" title="{{itemTitle}}" data-product-data-wrapper aria-label="{{itemTitle}}"  
			data-product-id="{{itemID}}" 
			data-product-handle="{{itemHandle}}" 
			data-product-url="{{itemUrl}}" 
			data-product-type="{{itemType}}" 
			data-product-image-default="{{itemDefaultImage}}" 
      {{itemHoverImage}}
			data-product-division="{{itemDivision}}" 
      data-product-sku="{{itemSKU}}" 
      data-variant-sku="{{itemSKU}}" 
			data-product-inventory="{{itemInventory}}" 
      data-variant-inventory="{{itemInventory}}" 
			data-variant-title="{{itemTitleNoColor}}" 
			data-variant-price="{{itemDataPrice}}" 
			data-variant-compare-at-price="{{itemDataCompareAtPrice}}" 
			{{productAvailable}} 
		> 
			{{oneillBlueTag}} 
			<div class="product__badge-wrapper {{extraOneillBlueClass}}" data-badge-wrapper>{{itemTags}} {{saleLabelHtml}}</div> 
			<div class="product-link__image {{itemHoverClass}}" data-product-image> 
			<picture class="img img--responsive img--portrait"> 
					{{itemThumbResponsive}} 
					<img class="lazyload main-image" src="{{itemThumbUrl}}" alt="{{itemTitle}}" width="{{itemThumbWidth}}" height="{{itemThumbHeight}}" /> 
				</picture> 
			    {{hoverImage}}
          {{variantColorSizes}}
			</div> 
		</a> 
		<div class="product-link__meta"> 
        <h2 class="product-link__title"><a href="{{itemUrl}}">{{itemTitleNoColor}}</a></h2> 
        <div class="product-link__meta-wrapper"> 
  		{{itemPrice}} 
          {{colorVariantTag}} 
        </div> 
      </div> 
      <button data-quickadd-button data-quickadd-id="{{itemID}}" data-quickadd-handle="{{itemHandle}}" class="button button--quick-add">${boostPFSThemeConfig.custom.quick_add}</button> 
    <a class="iWishAddColl iwishcheck" href="#" data-variant="{{variantID}}" data-product="{{itemID}}" data-pTitle="{{itemTitleNoColor}}">
      <span class="visually-hidden">Add to Wishlist</span>
    </a>
    </div>`,
  sortingHtml: `<select class="boost-pfs-filter-filter-dropdown">{{sortingItems}}</select>`,
};

// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_max,
    // Optional
    loadProductFirst: true,
    styleScrollToTop: "style2",
    defaultDisplay: boostPFSThemeConfig.custom.layout,
    showPlaceholderProductList: true,
    paginationTypeAdvanced: true,
    activeLoadPreviousPage: true,
    filterTreeMobileStyle: "style1",
  },
};

(function () {
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;

    var product = data;

    /*** Prepare product ***/
    var productID = product.id;
    var productHandle = product.handle;
    var images = product.images_info;

    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = product.variants[0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = product.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          firstVariant = product.variants[i];
          break;
        }
      }
    }

    product.selected_or_first_available_variant = firstVariant;
    var variantID = firstVariant.id;

    // Displaying price base on the policy of Shopify, have to multiple by 100
    var onSale =
      product.selected_or_first_available_variant.compare_at_price >
      product.selected_or_first_available_variant.price; // Check a product is on sale
    var priceVaries = product.price_varies; // Check a product has many prices

    // Get product labels set with 'pfs:label-' and get color variants
    var tags = "";
    var colorVariantTag = "";
    var targetGroup = "";
    var oneillBlueTag = "";

    for (var i = 0; i < product.tags.length; i++) {
      if (product.tags[i].indexOf("pfs:label-") !== -1) {
        tags = product.tags[i].split("pfs:label-")[1];
      }
      if (product.tags[i].indexOf("ItemNumber:") !== -1) {
        colorVariantTag = `<div class="variant-slider-wrapper swiper-container" data-swatches-slider>
          <div class="variant-wrapper swiper-wrapper" data-swatch-offset data-variant-wrapper-swatches data-color-variants="/collections/all/${product.tags[i]}?view=color-variants-swatches"></div>
          <div class="swiper-button-prev hidden"></div>
          <div class="swiper-button-next hidden"></div>
        </div>`;
      }
      if (product.tags[i].indexOf("TargetGroup:") !== -1) {
        targetGroup = product.tags[i].replace("TargetGroup:", "");
      }
      if (product.tags[i].indexOf("O'Neill Blue:yes") !== -1) {
        oneillBlueTag =
          '<div class="product-link__blue-badge bottom-left"><img src="//cdn.shopify.com/s/files/1/0490/0801/7561/files/ONeill_Blue_small.jpg?v=1623336957" alt="ONeill Blue"></div>';
      }
    }

    // check for O'Neill Blue
    // for (var i = 0; i < product.metafields.length; i++) {
    //  if (product.metafields[i].key == "O'Neill Blue") {
    //    if (product.metafields[i].value == "Yes") {
    //      oneillBlue = true;
    //    }
    //  }
    // }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // set responsive image if image is available
    if (images.length > 0) {
      var sizes = [],
        media_queries = [],
        product_image,
        images_arr = [],
        images_default_arr = [],
        images_hover_arr = [],
        images_retina_arr = [],
        retina_x2,
        default_image;
      var extensions = Settings.getSettingValue("general.imageExtension");
      // same dimensions are set in responsive-image for product-link
      sizes = [280, 280, 290, 192, 140];
      media_queries = ["2560px", "1280px", "620px", "425px", "print"];

      for (var s = 0; s < sizes.length; s++) {
        // loop through all extensions and if our image has that extension, append the different responsive sizes to it
        for (var index = 0; index < extensions.length; index++) {
          if (images[0]["src"].indexOf(extensions[index]) > -1) {
            default_image = images[0]["src"].replace(
              "." + extensions[index] + "?",
              "_" + sizes[s] + "x.progressive." + extensions[index] + "?"
            );
            retina_x2 = images[0]["src"].replace(
              "." + extensions[index] + "?",
              "_" + sizes[s] * 2 + "x.progressive." + extensions[index] + "?"
            );

            // push images into array
            images_default_arr.push(default_image);
            images_retina_arr.push(retina_x2);
          }
          if (images.length > 1) {
            hover_image = images[1]["src"].replace(
              "." + extensions[index] + "?",
              "_" + sizes[s] * 2 + "x.progressive." + extensions[index] + "?"
            );
            // push images into array
            images_hover_arr.push(hover_image);
          }
        }
        product_image =
          '<source media="(max-width: ' +
          media_queries[s] +
          ')" srcset="' +
          default_image +
          " 1x, " +
          retina_x2 +
          ' 2x" src="' +
          default_image +
          '">';
        images_arr.push(product_image);
      }

      itemHtml = itemHtml.replace(
        /{{itemThumbResponsive}}/g,
        images_arr.join("")
      );
      var itemThumbUrl = images_default_arr[4];
      itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
      itemHtml = itemHtml.replace(/{{itemThumbWidth}}/g, sizes[4]);
      itemHtml = itemHtml.replace(
        /{{itemThumbHeight}}/g,
        Math.floor(sizes[4] * 1.5357)
      );
      itemHtml = itemHtml.replace(/{{noImage}}/g, "");
      itemHtml = itemHtml.replace(
        /{{itemDefaultImage}}/g,
        images_retina_arr[2]
      );

      if (
        (images_hover_arr[2] !== null ||
          images_hover_arr[2] !== "undefined" ||
          images_hover_arr[2] !== "") &&
        typeof images_hover_arr[2] !== "undefined"
      ) {
        var hoverAttr =
          'data-product-image-hover="' + images_hover_arr[2] + '"';
        itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, hoverAttr);
        var hoverImageHtml =
          ' <img class="lazyload hover-image" src="' +
          images_hover_arr[2] +
          '" alt="{{itemTitle}}" width="' +
          sizes[4] +
          '" height="' +
          Math.floor(sizes[4] * 1.5357) +
          '" /> ';
        itemHtml = itemHtml.replace(/{{hoverImage}}/g, hoverImageHtml);
        itemHtml = itemHtml.replace(
          /{{itemHoverClass}}/g,
          " hover-image-enabled"
        );
      }
    } else {
      // no images - will be removed
      itemHtml = itemHtml.replace(/{{noImage}}/g, "data-no-image");
      itemHtml = itemHtml.replace(/{{itemThumbResponsive}}/g, "");
      itemHtml = itemHtml.replace(
        /{{itemThumbUrl}}/g,
        boostPFSConfig.general.no_image_url
      );
    }
    itemHtml = itemHtml.replace(/{{hoverImage}}/g, "");
    itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, "");
    // Add Labels
    var itemLabelHtml = "";
    if (tags !== "") {
      itemLabelHtml += '<span class="product__badge">' + tags + "</span>";
    }
    itemHtml = itemHtml.replace(/{{itemTags}}/g, itemLabelHtml);

    // Add O'Neill Blue
    // var blueLabel = '';
    // if (oneillBlue) {
    //   blueLabel = '<div class="product-link__blue-badge '+boostPFSConfig.custom.oneillBlue_pos+'"><img src="'+boostPFSConfig.custom.oneillBlue_image+'" alt="O\'Neill Blue"></div>';
    //   // add extra class to the product badge wrapper when Oneill blue is set, so that extra margin can be set to the discount badges
    //   itemHtml = itemHtml.replace(/{{extraOneillBlueClass}}/g, 'product__badge-wrapper--extra-margin');
    // }
    // itemHtml = itemHtml.replace(/{{blueLabel}}/g, blueLabel);

    // Add Price
    var itemPriceHtml = "";
    if (onSale) {
      itemPriceHtml +=
        '<div class="product-price-wrapper" data-price-wrapper><span class="product-price product-price--sale">' +
        Utils.formatMoney(product.price_min) +
        '</span> <s class="product-price product-price--sale-old">' +
        Utils.formatMoney(product.compare_at_price_max) +
        "</s></div>";
      itemHtml = itemHtml.replace(
        /{{itemDataCompareAtPrice}}/g,
        product.compare_at_price_max
      );
    } else if (priceVaries) {
      itemPriceHtml +=
        '<div class="product-price-wrapper" data-price-wrapper><span class="product-price product-price--default">' +
        boostPFSConfig.label.from_price.replace(
          /{{ html }}/g,
          Utils.formatMoney(product.price_min)
        ) +
        "</span></div>";
      itemHtml = itemHtml.replace(
        /{{itemDataCompareAtPrice}}/g,
        product.compare_at_price_max
      );
    } else {
      itemPriceHtml +=
        '<div class="product-price-wrapper" data-price-wrapper><span class="product-price product-price--default">' +
        Utils.formatMoney(product.price_min) +
        "</span></div>";
      itemHtml = itemHtml.replace(/{{itemDataCompareAtPrice}}/g, "");
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    itemHtml = itemHtml.replace(/{{itemDataPrice}}/g, product.price_min);

    // Product availability
    if (product.available) {
      itemHtml = itemHtml.replace(/{{productAvailable}}/g, "");
    } else {
      itemHtml = itemHtml.replace(
        /{{productAvailable}}/g,
        'data-variant-unavailable="' + product.available + '"'
      );
    }

    // Add color variant
    itemHtml = itemHtml.replace(/{{colorVariantTag}}/g, colorVariantTag);

    // Add Oneill Blue
    itemHtml = itemHtml.replace(/{{oneillBlueTag}}/g, oneillBlueTag);

    // Add ID
    itemHtml = itemHtml.replace(/{{itemID}}/g, productID);
    itemHtml = itemHtml.replace(/{{variantID}}/g, variantID);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, productHandle);

    // Add tags
    itemHtml = itemHtml.replace(/{{itemTags}}/g, tags);

    // Add 'On Sale' badge
    var itemSaleLabelHtml = "";
    if (onSale) {
      var onSalePerc = Math.floor(
        ((product.selected_or_first_available_variant.compare_at_price -
          product.selected_or_first_available_variant.price) *
          100) /
          product.selected_or_first_available_variant.compare_at_price
      );
      itemSaleLabelHtml +=
        '<div class="product__badge" data-badge-discount><span data-badge-discount-percentage>-' +
        onSalePerc +
        "%</span></div>";
    } else if (priceVaries) {
      itemSaleLabelHtml +=
        '<div class="product__badge" data-badge-discount>' +
        boostPFSConfig.label.sale +
        "</div>";
    }
    itemHtml = itemHtml.replace(/{{saleLabelHtml}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorHtml.replace(
          /{{itemVendorLabel}}/g,
          product.vendor
        )
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, product.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, product.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, product.title);
    itemHtml = itemHtml.replace(
      /{{itemTitleNoColor}}/g,
      product.title.split("|")[0]
    );
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/products/" + product.handle);
    itemHtml = itemHtml.replace(/{{itemType}}/g, product.product_type);
    itemHtml = itemHtml.replace(/{{itemDivision}}/g, targetGroup);
    itemHtml = itemHtml.replace(
      /{{itemInventory}}/g,
      product.selected_or_first_available_variant.inventory_quantity
    );
    itemHtml = itemHtml.replace(
      /{{itemSKU}}/g,
      product.selected_or_first_available_variant.sku
    );

    var availableVariantSizes = product.variants.reduce((array, variant) => {
      if (variant.available) {
        array.push({
          id: variant.id,
          size: variant.option_size,
        });
      }

      return array;
    }, []);

    var sizeButtons = availableVariantSizes.reduce((a, c) => {
      a += `<button data-instant-add-button data-instant-add-id="${c.id}" class="instant-add-size-button">${c.size}</button>`;
      return a;
    }, "");

    itemHtml = itemHtml.replace(
      /{{variantColorSizes}}/g,
      `<div class="instant-add-size-buttons ${
        availableVariantSizes.length >= 4 ? "instant-add-wide" : ""
      }" data-size-buttons>${sizeButtons}</div>`
    );

    return itemHtml;
  };

  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    return ProductGridItem.prototype.compileTemplate(data);
  };

  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1
        ? boostPFSTemplate.previousActiveHtml
        : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? boostPFSTemplate.nextActiveHtml
        : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      html = boostPFSTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
    }
    return html;
  };

  /************************** END BUILD TOOLBAR **************************/
  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    loadVariantSwatches();

    // remove products without an image
    $("[data-no-image]").remove();

    // hide products before load
    $(".collection-products").fadeIn("fast");

    /** show collection promos **/
    // if on page 1 of collection, check if there are promo items available, if so, append them to the grid and hide the section wrapper
    var pagCurr = $(".pagination").data("pagination-current");
    if (
      $(".collection-promo").length &&
      window.location.search.indexOf("pf") === -1
    ) {
      $(".collection-promo__item").appendTo(".boost-pfs-filter-products");

      // if on page 1 of collection, show only items that should be loaded in first 12 products
      if (
        pagCurr == "1" ||
        typeof pagCurr === "undefined" ||
        window.location.search === ""
      ) {
        var mobile = [1, 2, 3, 4, 5, 6];
        var tablet = [1, 2, 3, 4];
        var desktop = [1, 2, 3];

        if ($.code.ww < 620) {
          $.each(mobile, function (index, value) {
            $('[data-grid-row-s="' + value + '"]').fadeIn("fast");
          });
        } else if ($.code.ww >= 620 && $.code.ww < 990) {
          $.each(tablet, function (index, value) {
            $('[data-grid-row-m="' + value + '"]').fadeIn("fast");
          });
        } else {
          $.each(desktop, function (index, value) {
            $('[data-grid-row-l="' + value + '"]').fadeIn("fast");
          });
        }
      }
      // remove elements if user enters on page > 1
      else if (pagCurr > "1") {
        $(".collection-promo__item").remove();
      }

      // Check if we're in the customizer
      if (Shopify.designMode) {
        $(".boost-pfs-filter-products").append(
          $(".collection-promo-wrapper .collection-promo__item")
        );
        $(".collection-promo-wrapper").html("");

        $(document).on("shopify:block:select", function (e) {
          e.stopImmediatePropagation();
          $(".boost-pfs-filter-products")
            .find(".collection-promo__item")
            .remove();
          if (e.detail.load) {
            $(".boost-pfs-filter-products").append(
              $(".collection-promo-wrapper .collection-promo__item")
            );
            $(".collection-promo-wrapper").html("");
          } else {
            $(".collection-promo-wrapper").html("");
          }
        });
      } else {
        $(".collection-promo-wrapper").remove();
      }
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    /** 2$ Wishlist app - The app information has to be reloaded when additional elements are loaded **/
    var iwish_cid = "{{ customer.id }}";
    //Add to Wishlist - Collection Page Text
    var iwish_added_txt_col =
      '<span class="visually-hidden">Added in Wishlist</span><i class="icon icon--lg icon--heart icon--heart-selected" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 28 24.09"><path d="M9.5,5A7.53,7.53,0,0,0,2,12.5a6.49,6.49,0,0,0,1.25,3.56,8.87,8.87,0,0,0,1.22,1.47L15.28,28.38l.72.71.72-.71L27.53,17.53S30,15.36,30,12.5A7.53,7.53,0,0,0,22.5,5,9.14,9.14,0,0,0,16,7.94,9.14,9.14,0,0,0,9.5,5Zm0,2c3,0,5.75,2.91,5.75,2.91l.75.84.75-.84S19.51,7,22.5,7A5.52,5.52,0,0,1,28,12.5c0,1.54-1.88,3.62-1.88,3.62L16,26.25,5.88,16.12a7.42,7.42,0,0,1-1-1.18A4.86,4.86,0,0,1,4,12.5,5.52,5.52,0,0,1,9.5,7Z" transform="translate(-2 -5)"/></svg></i>';
    var iwish_add_txt_col =
      '<span class="visually-hidden">Add to Wishlist</span><i class="icon icon--lg icon--heart" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 28 24.09"><path d="M9.5,5A7.53,7.53,0,0,0,2,12.5a6.49,6.49,0,0,0,1.25,3.56,8.87,8.87,0,0,0,1.22,1.47L15.28,28.38l.72.71.72-.71L27.53,17.53S30,15.36,30,12.5A7.53,7.53,0,0,0,22.5,5,9.14,9.14,0,0,0,16,7.94,9.14,9.14,0,0,0,9.5,5Zm0,2c3,0,5.75,2.91,5.75,2.91l.75.84.75-.84S19.51,7,22.5,7A5.52,5.52,0,0,1,28,12.5c0,1.54-1.88,3.62-1.88,3.62L16,26.25,5.88,16.12a7.42,7.42,0,0,1-1-1.18A4.86,4.86,0,0,1,4,12.5,5.52,5.52,0,0,1,9.5,7Z" transform="translate(-2 -5)"/></svg></i>';
    function iWishLoadScript(e, t) {
      for (var a = 0; a < e.length; a++) {
        var n = document.createElement("script");
        (n.type = "text/javascript"),
          (n.async = !0),
          (n.src = e[a]),
          document.getElementsByTagName("head")[0].appendChild(n),
          0 == a &&
            (n.readyState
              ? (n.onreadystatechange = function () {
                  ("loaded" !== n.readyState && "complete" !== n.readyState) ||
                    ((n.onreadystatechange = null), t());
                })
              : (n.onload = function () {
                  t();
                }));
      }
    }
    var iWishUrls = ["https://cdn.myshopapps.com/iwish/iwishlist_v2.js"];
    iWishLoadScript(iWishUrls, function () {
      jQuery("a[href='/apps/iwish']").click(function (e) {
        if (typeof Storage !== "undefined") {
          e.preventDefault();
          iWishPost("/apps/iwish", {
            iwishlist: JSON.stringify(iWishlistmain),
            cId: iwish_cid,
          });
        }
      });
      // Collection page - Default behaviour was changed, so the user can also remove a product from the wishlist by second clicking on it
      jQuery(".iWishAddColl").click(function () {
        var iWishvId = jQuery(this).attr("data-variant");
        if (jQuery(this).hasClass("iwishAdded")) {
          if (iwish_remove(jQuery(this), iWishvId)) {
            jQuery(this).removeClass("iwishAdded").html(iwish_add_txt_col);
          }
        } else {
          iwish_addCollection(jQuery(this), iWishvId);
        }
        return false;
      });
      iwishCheckColl();
    });
    // Collection - Default behaviour was changed, so the user can also remove a product from the wishlist by second clicking on it
    function iwishCheckColl() {
      if (jQuery(".iwishcheck").length > 0) {
        jQuery(".iwishcheck").each(function () {
          var iWishvId = jQuery(this).attr("data-variant");
          var iWishpId = jQuery(this).attr("data-product");
          if (isInWishlist(iWishpId, iWishvId)) {
            jQuery(this).addClass("iwishAdded").html(iwish_added_txt_col);
          }
          jQuery(this).removeClass("iwishcheck");
        });
      }
    }

    /** End of 2$ Wishlist **/

    if ($(".js-boost-pfs-filter-btn-load-previous-page").length === 0) {
      $(".js-boost-pfs-filter-btn-load-previous-page").addClass(
        "button--secondary"
      );
    }

    // append close button to filters
    if ($(".filter-button--apply").length === 0) {
      $(".boost-pfs-filter-tree").append(
        '<button class="button button--collection filter-button--apply">' +
          boostPFSConfig.custom.close +
          "</button>"
      );
    }

    // add 'clear all' button when filters are active
    if (window.location.search.indexOf("pf") !== -1) {
      jQ(".boost-pfs-filter-clear-all").show();
    }

    /* total products */
    var total_products =
      data.total_product === 1
        ? boostPFSConfig.label.items_with_count_one
        : boostPFSConfig.label.items_with_count_other;
    jQ(".boost-pfs-filter-total-products").html(
      total_products.replace(/{{ count }}/g, data.total_product)
    );
  };

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function (a, b) {};

  FilterTree.prototype.afterRender = function () {
    $(".filter__title").append(this.clearAllButton.$element);
  };
})();
